/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'fabric.atlassianSwitcher.administration': 'Administração',
  'fabric.atlassianSwitcher.analytics': 'Dados de análise',
  'fabric.atlassianSwitcher.assets': 'Recursos',
  'fabric.atlassianSwitcher.atlassianHome': 'Página inicial',
  'fabric.atlassianSwitcher.atlassianWebsiteTryProducts': 'Experimente os produtos da Atlassian',
  'fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription': 'Colaboração de documentos',
  'fabric.atlassianSwitcher.chat': 'Bate-papo',
  'fabric.atlassianSwitcher.companyHub': 'Hub da empresa',
  'fabric.atlassianSwitcher.confluenceDescriptionText': 'Documente e colabore',
  'fabric.atlassianSwitcher.confluenceSpace': 'Espaço do Confluence',
  'fabric.atlassianSwitcher.emptyState.exploreProducts.body': 'Teste um produto para começar a colaborar com a equipe.',
  'fabric.atlassianSwitcher.emptyState.exploreProducts.link': 'Conheça os produtos',
  'fabric.atlassianSwitcher.emptyState.exploreProducts.title': 'Comece a usar a nuvem',
  'fabric.atlassianSwitcher.errorEmptyPartialResults': 'Não é possível exibir os apps agora.',
  'fabric.atlassianSwitcher.errorFlag.description':
    'Tente outra vez em alguns minutos. Se ainda não for possível entrar, <a>entre em contato com o suporte</a>.',
  'fabric.atlassianSwitcher.errorFlag.title': 'Não foi possível adicionar você ao {product}',
  'fabric.atlassianSwitcher.errorHeading': 'Algo deu errado',
  'fabric.atlassianSwitcher.errorHeadingLoggedOut': 'Você saiu da conta da Atlassian',
  'fabric.atlassianSwitcher.errorHeadingUnverified': 'Esta conta não foi verificada',
  'fabric.atlassianSwitcher.errorImageAltText': 'Um robô quebrado e várias pessoas ocupadas no conserto dele.',
  'fabric.atlassianSwitcher.errorPartialResults': 'Não é possível exibir alguns apps agora.',
  'fabric.atlassianSwitcher.errorPartialResultsRefresh': 'Atualize a página ou tente de novo mais tarde.',
  'fabric.atlassianSwitcher.errorText':
    'Nós acompanhamos esses erros, mas fique à vontade para entrar em contato conosco caso a atualização não resolva as coisas',
  'fabric.atlassianSwitcher.errorTextLoggedOut': 'Entre de novo para usar o Atlassian Switcher.',
  'fabric.atlassianSwitcher.errorTextNetwork':
    'Não foi possível carregar esta lista. Recarregue a página e tente novamente.',
  'fabric.atlassianSwitcher.errorTextUnverified':
    'Confirme o endereço de e-mail para ver uma lista de produtos disponíveis.',
  'fabric.atlassianSwitcher.goals': 'Metas',
  'fabric.atlassianSwitcher.home': 'Atlassian Home',
  'fabric.atlassianSwitcher.instantAccessStatusText': 'Acesso instantâneo',
  'fabric.atlassianSwitcher.jiraDescriptionText': 'Planeje e acompanhe a entrega do projeto',
  'fabric.atlassianSwitcher.jiraProject': 'Projeto do Jira',
  'fabric.atlassianSwitcher.join': 'Entrar',
  'fabric.atlassianSwitcher.joinStatusText': 'Entrar',
  'fabric.atlassianSwitcher.joinTeamStatusText': 'Faça parte da equipe',
  'fabric.atlassianSwitcher.jpdDescriptionText': 'Priorize e planeje novas ideias',
  'fabric.atlassianSwitcher.jsmDescriptionText': 'Automatize e ofereça suporte de TI',
  'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription':
    'Gerencie projetos para equipes empresariais',
  'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription':
    'Gerencie projetos empresariais sem custos com o Jira Software',
  'fabric.atlassianSwitcher.login': 'Entrar',
  'fabric.atlassianSwitcher.manageList': 'Gerenciar lista',
  'fabric.atlassianSwitcher.modalLabel': 'Gerenciador de Aplicativos da Atlassian',
  'fabric.atlassianSwitcher.more': 'Mais',
  'fabric.atlassianSwitcher.newLozenge': 'Novo',
  'fabric.atlassianSwitcher.organisationsLabel': 'Organizações',
  'fabric.atlassianSwitcher.product.description.compass': 'Gerenciador de componentes',
  'fabric.atlassianSwitcher.product.description.confluence': 'Colaboração de documentos',
  'fabric.atlassianSwitcher.product.description.jsm': 'Gerenciamento de serviço de TI colaborativo',
  'fabric.atlassianSwitcher.product.description.jsw': 'Monitoramento de projetos e itens',
  'fabric.atlassianSwitcher.product.description.opsgenie': 'Gerenciamento de incidentes moderno',
  'fabric.atlassianSwitcher.requestAccessStatusText': 'Solicitar acesso',
  'fabric.atlassianSwitcher.requestSentStatusText': 'Solicitação enviada',
  'fabric.atlassianSwitcher.resizeBarLabel': '"Expandir" ou "Recolher", dependendo do estado',
  'fabric.atlassianSwitcher.resizeBarTooltipCollapsed': 'Arraste para redimensionar{separator}Pressione para expandir',
  'fabric.atlassianSwitcher.resizeBarTooltipExpanded': 'Arraste para redimensionar{separator}Pressione para recolher',
  'fabric.atlassianSwitcher.resizeBarValueTextLabel': 'Largura',
  'fabric.atlassianSwitcher.search': 'Pesquisar',
  'fabric.atlassianSwitcher.sites': '{numSites, plural, one {{productName} site} other {{productName} sites}}',
  'fabric.atlassianSwitcher.skeletonLoaderAriaLabel': 'O Gerenciador de Aplicativos está carregando',
  'fabric.atlassianSwitcher.start': 'Página inicial da Atlassian',
  'fabric.atlassianSwitcher.startAriaLabel': 'A página inicial da Atlassian vai abrir em uma nova guia',
  'fabric.atlassianSwitcher.studio': 'Estúdio',
  'fabric.atlassianSwitcher.successFlag.description': 'Você vai receber um e-mail quando a solicitação for aprovada',
  'fabric.atlassianSwitcher.successFlag.title': 'Solicitação de acesso enviada ao administrador',
  'fabric.atlassianSwitcher.switchSitesOrAppsTooltip': 'Trocar sites ou aplicativos',
  'fabric.atlassianSwitcher.switchTo': 'Alternar para',
  'fabric.atlassianSwitcher.switchToTooltip': 'Alternar para…',
  'fabric.atlassianSwitcher.teams': 'Equipes',
  'fabric.atlassianSwitcher.tryLozenge': 'Testar',
  'fabric.atlassianSwitcher.yourApps': 'Seus aplicativos',
  'fabric.atlassianSwitcher.yourAppsTooltip': 'Seus aplicativos…',
};
